import React from "react";
import { PAGE_TITLE } from "@/common/constants/constants";
import browseJobByLocationDataFetch from "@/data/domain/browse-job-by-location.json";
import { v4 as uuidv4 } from "uuid";

import styles from "../../styles/BrowseBy.module.scss";
import Link from "next/link";

const BrowseByLocation = () => {
  return (
    <div className={styles.wrapper}>
      <h1>{PAGE_TITLE.BROWSE_BY_LOCATION}</h1>
      <div className={styles.cardsWrapper}>
        {browseJobByLocationDataFetch.map((item) => {
          return (
            <Link
              href={{
                pathname: "/jobs",
                query: {
                  location: item.value.replaceAll(",", ""),
                },
              }}
              key={uuidv4()}
            >
              <div className={styles.card} key={uuidv4()}>
                {item.value}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BrowseByLocation;
